import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import routes from './routes';

import { Router, browserHistory } from 'react-router';
import { API_BASE } from './config';

ReactDOM.render(
  <Router routes={routes} history={browserHistory} />,
  document.getElementById('root')
);

function checkSignIn() {
  
	if (localStorage.getItem('token')) {
	  var request = new Request(`${API_BASE}auth/login/`+localStorage.getItem('token'), {
	    method: 'POST', 
	    mode: 'cors', 
	    headers: new Headers({})
	  });

	  fetch(request).then(function(response) {
	      return response.json();
	  }).then(function(json) {
	     // do nothing
	  }).catch(function(ex) {
	    localStorage.setItem('user_id','0');
	    localStorage.setItem('token','');
	    window.location.reload();
	  });
	}
	
}


// WEBPACK FOOTER //
// ./src/index.js